import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, mergeProps as _mergeProps, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed } from 'vue'
import usePagination from './usePagination'

export default /*#__PURE__*/_defineComponent({
  props: {
  className: {
    type: String,
    default: 'flex-end'
  },
  // 是否显示分页
  showPagination: {
    type: Boolean,
    require: true,
    default: true
  },
  // 分页数据
  pageData: {
    type: Object,
    default: () => ({
      limit: 30,
      page: 1
    })
  },
  /**
   * https://element-plus.gitee.io/zh-CN/component/pagination.html#%E5%B1%9E%E6%80%A7
   *
   * total: 0,
   * current: 1,
   * pageSize: 30,
   * pageSizes: [10, 20, 30, 50],
   * layout: ' prev, pager, next, sizes, jumper ',
   * background: true
   */
  paginationConfig: {
    type: Object,
    default: () => ({})
  },
  total: {
    type: Number,
    default: 0
  }
},
  emits: ['update:page-data'],
  setup(__props, { emit: emits }) {

const props = __props


const _paginationConfig = computed(() => {
  const config = {
    total: 0,
    current: 1,
    pageSize: 30,
    pageSizes: [10, 20, 30, 50],
    layout: ' prev, pager, next, sizes, jumper ',
    background: true
  }
  return Object.assign(config, props.paginationConfig)
})
const { pageSize, currentPage } = usePagination(props, emits)

return (_ctx: any,_cache: any) => {
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (__props.showPagination && __props.total > 0)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(__props.className)
      }, [
        _createVNode(_component_el_pagination, _mergeProps(_unref(_paginationConfig), {
          total: __props.total,
          pageSize: _unref(pageSize),
          "onUpdate:pageSize": _cache[0] || (_cache[0] = ($event: any) => (_isRef(pageSize) ? (pageSize).value = $event : null)),
          currentPage: _unref(currentPage),
          "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => (_isRef(currentPage) ? (currentPage).value = $event : null))
        }), null, 16, ["total", "pageSize", "currentPage"])
      ], 2))
    : _createCommentVNode("", true)
}
}

})